// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d5352479","186":"8a48d565","225":"f9149d44","272":"20921a01","372":"8bfa84f8","377":"fd305b95","738":"a1dcce0e","841":"953e1cd1","856":"a3be3672"}[chunkId] + ".chunk.js";
};